export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-14 bg-background-100 rounded-lg p-6 md:p-10 border border-background-200/70">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              移动追剧
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-6 leading-relaxed">
              蓝莓影院全面适配手机浏览器，无需下载APP即可随时随地追剧。
              打开手机浏览器访问，享受与桌面端一致的高清流畅播放体验，让追剧不受时间和地点限制。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2 rounded-md bg-background-200/70 text-sm text-foreground-700">
                <i className="ri-smartphone-line text-lg"></i>
                <span>手机浏览器访问</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-md bg-background-200/70 text-sm text-foreground-700">
                <i className="ri-tablet-line text-lg"></i>
                <span>平板适配</span>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-80 bg-background-200 rounded-2xl border-4 border-background-300 overflow-hidden shadow-lg">
              <div className="w-full h-full flex flex-col items-center justify-center p-4">
                <div className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center mb-3">
                  <i className="ri-play-circle-line text-white text-2xl"></i>
                </div>
                <span className="font-heading text-sm text-foreground-700">蓝莓影院</span>
                <span className="text-[10px] text-foreground-400 mt-1">追剧随时随地</span>
                <div className="mt-3 w-full h-1.5 rounded-full bg-background-300"></div>
                <div className="mt-2 w-3/4 h-1.5 rounded-full bg-background-300"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}